<template>
  <div class="home-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-notice-bar v-if="notice_text != ''" background="#f0dadc" color="black" left-icon="volume-o"
        :text="notice_text" />

      <div class="page-hero">
        <div>
          <div class="page-hero-title">权益激活</div>
          <div class="page-hero-desc">查看并激活您的权益券</div>
        </div>
        <div class="page-hero-badge">会员权益</div>
      </div>

      <van-tabs class="main-tabs" swipe-threshold='3' @click='selects' :active="active" shrink>
        <van-tab title="商超代金券">
          <van-tabs @click='selectstatus' class='navtab' title-active-color='black' v-model="actives" animated>
            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">
              <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false"
                @load="loadings">
                <van-empty
                  v-if="finished && list.length === 0"
                  class="coupon-empty"
                  image="search"
                  :description="getEmptyText('coupon')"
                />
                <div v-for="(i,ind) in list" :key="ind" class="coupon-card">
                  <div class="coupon-logo">
                    <img :src="i.logo" alt="">
                  </div>
                  <div class="coupon-main">
                    <div class="coupon-title">{{ i.storeName }}</div>
                    <div class="coupon-desc">满{{ i.transactionMinimum }}可用</div>
                    <div class="coupon-time">有效期至 {{ i.effectiveTimeEnd }}</div>
                  </div>
                  <div class="coupon-side">
                    <van-button
                      v-if="i.status == 0 && status != 2"
                      class="coupon-action"
                      size="small"
                      @click="activated(i.id)"
                    >
                      立即激活
                    </van-button>
                    <wx-open-launch-weapp v-else-if="i.status == '1' && i.enterpriseType == '2'" username="gh_6213b326c9f6">
                      <script type="text/wxtag-template">
                        <style>.btn { background-color: #cb4643; color: #fff; padding: 0.18rem 0.32rem; text-align: center; border-radius: 1rem; border: none; font-size: 0.28rem; }</style>
                        <button class="btn">去使用</button>

                                                  </script>
                    </wx-open-launch-weapp>
                    <span v-else class="coupon-status" :class="getCouponStatusClass(i.status)">
                      {{ getCouponStatusText(i.status) }}
                    </span>
                  </div>
                </div>
              </van-list>
            </van-tab>
          </van-tabs>
        </van-tab>
<!--        <van-tab title="充值券" v-if="shows == 15">-->
<!--          <van-tabs @click='selectstatus' class='navtab' title-active-color='black' v-model="activess" animated>-->
<!--            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">-->
<!--              <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false"-->
<!--                @load="loadings">-->
<!--                <div v-for="(i,ind) in list" :key="ind" class="qy-content qy-fen">-->
<!--                  <div class="qy-content-img">-->
<!--                    <img :src="i.logo">-->
<!--                  </div>-->
<!--                  <div class="qy-content-info">-->
<!--                    <span>{{ i.storeName }}</span>-->
<!--                    <span class="transaction">满{{ i.transactionMinimum }}可用 </span>-->
<!--                    <span :style="{ color: (status == 0 ? '#CB4643' : '#999999') }">-->
<!--                      {{ i.effectiveTimeEnd }}-->
<!--                    </span>-->
<!--                  </div>-->
<!--                  <div v-show="i.status == 0" class="qy-button  qy-button-fen" @click="activated(i.id)">-->
<!--                    <span>激活</span>-->
<!--                  </div>-->
<!--                  <div style="position: absolute; right: 0.1rem; top:0.8rem; font-size: 0.5rem;">-->
<!--                    <wx-open-launch-weapp v-if="i.status >= '1' && i.enterpriseType == '2'" username="gh_6213b326c9f6">-->
<!--                      <script type="text/wxtag-template">-->
<!--                        <style>.btn {  background-color: rgb(255, 255, 255);-->
<!--                                                                                                                                                    padding: 0.25rem 0.5rem;-->
<!--                                                                                                                                                    text-align: center;-->
<!--                                                                                                                                                    border-radius: 1rem;border: none;}</style>-->
<!--                                                                                                                                                     <button class="btn">去使用</button>-->

<!--                                                      </script>-->
<!--                    </wx-open-launch-weapp>-->
<!--                  </div>-->
<!--                  <div v-show="i.status != 0" style='position: absolute;-->
<!--                  right: -0.1rem;-->
<!--    top: -0.6rem;'>-->
<!--                    <img v-show="i.status == 0" style="width: 1.5rem;" src="../../assets/img2/wjh.png">-->
<!--                    <img v-show="i.status == 1" style="width:1.5rem;" src="../../assets/img2/yjh.png">-->
<!--                    <img v-show="i.status == 2" style="width: 1.5rem;" src="../../assets/img2/ysy.png">-->
<!--                  </div>-->
<!--                </div>-->
<!--              </van-list>-->
<!--            </van-tab>-->
<!--          </van-tabs>-->
<!--        </van-tab>-->
        <van-tab title="出行会员">
          <van-tabs @click='selectfyStatus' class='navtab' title-active-color='black' v-model="fyActives" animated>
            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">
              <van-list v-model="hyLoading" :finished="hyFinished" finished-text="没有更多了" :immediate-check="false"
                @load="hyLoadings">
                <van-empty
                  v-if="hyFinished && hyList.length === 0"
                  class="coupon-empty"
                  image="search"
                  :description="getEmptyText('member')"
                />
                <div v-for="(i,ind) in hyList" :key="ind" class="coupon-card">
                  <div class="coupon-logo">
                    <img :src="i.couponLogo" alt="">
                  </div>
                  <div class="coupon-main">
                    <div class="coupon-title">{{ i.couponName }}</div>
                    <div class="coupon-desc">{{ i.couponUseDesc }}</div>
                    <div class="coupon-time">有效期至 {{ i.endTime }}</div>
                  </div>
                  <div class="coupon-side">
                    <van-button
                      v-if="i.status == 0"
                      class="coupon-action"
                      size="small"
                      @click="hyActivated(i.userCouponId)"
                    >
                      立即激活
                    </van-button>
                    <span v-else class="coupon-status" :class="getMemberStatusClass(i.status)">
                      {{ getMemberStatusText(i.status) }}
                    </span>
                  </div>
                </div>
              </van-list>
            </van-tab>
          </van-tabs>
        </van-tab>
<!--        <van-tab title="美食商超">-->
<!--          <van-tabs @click='selectstatus' class='navtab' title-active-color='black' v-model="actives" animated>-->
<!--            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">-->
<!--              <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false"-->
<!--                @load="loadings">-->
<!--                <div v-for="(i,ind) in list" :key="ind" class="qy-content qy-fen">-->
<!--                  <div class="qy-content-img">-->
<!--                    <img :src="i.logo">-->
<!--                  </div>-->
<!--                  <div class="qy-content-info">-->
<!--                    <span>{{ i.storeName }}</span>-->
<!--                    <span class="transaction">满{{ i.transactionMinimum }}可用 </span>-->
<!--                    <span :style="{ color: (status == 0 ? '#CB4643' : '#999999') }">-->
<!--                      {{ i.effectiveTimeEnd }}-->
<!--                    </span>-->
<!--                  </div>-->
<!--                  <div v-show="i.status == 0 && status != 2" class="qy-button  qy-button-fen" @click="activated(i.id)">-->
<!--                    <span>激活</span>-->
<!--                  </div>-->
<!--                  <div style="position: absolute; right: 0.1rem; top:0.8rem; font-size: 0.5rem;">-->
<!--                    <wx-open-launch-weapp v-if="i.status == '1' && i.enterpriseType == '2'" username="gh_6213b326c9f6">-->
<!--                      <script type="text/wxtag-template">-->
<!--                        <style>.btn {  background-color: rgb(255, 255, 255);-->
<!--                                                                                                                                              padding: 0.25rem 0.5rem;-->
<!--                                                                                                                                              text-align: center;-->
<!--                                                                                                                                              border-radius: 1rem;border: none;}</style>-->
<!--                                                                                                                                               <button class="btn">去使用</button>-->

<!--                                                  </script>-->
<!--                    </wx-open-launch-weapp>-->
<!--                  </div>-->
<!--                  <div v-show="i.status != 0" style='position: absolute;-->
<!--          right: 0.3rem;-->
<!--          top: 0.3rem;'>-->
<!--                    <img v-show="i.status == 0" style="width: 2rem;" src="../../assets/img2/wjh.png">-->
<!--                    <img v-show="i.status == 1 && i.enterpriseType != '2'" style="width: 2rem;"-->
<!--                      src="../../assets/img2/yjh.png">-->
<!--                    <img v-show="i.status == 2" style="width: 2rem;" src="../../assets/img2/ysy.png">-->
<!--                    &lt;!&ndash; <span v-show="i.status == 0">未激活</span> &ndash;&gt;-->
<!--                    &lt;!&ndash; <span v-show="i.status == 1">已激活</span> &ndash;&gt;-->
<!--                    &lt;!&ndash; <span v-show="i.status == 2">已使用</span> &ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </van-list>-->
<!--            </van-tab>-->
<!--          </van-tabs>-->
<!--        </van-tab>-->
<!--        <van-tab title="美食会员">-->
<!--          <van-tabs @click='selectfyStatus' class='navtab' title-active-color='black' v-model="fyActives" animated>-->
<!--            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">-->
<!--              <van-list v-model="hyLoading" :finished="hyFinished" finished-text="没有更多了" :immediate-check="false"-->
<!--                @load="loadings">-->
<!--                <div v-for="(i,ind) in hyList" :key="ind" class="qy-content qy-fen">-->
<!--                  <div class="qy-content-img">-->
<!--                    <img :src="i.couponLogo">-->
<!--                  </div>-->
<!--                  <div class="qy-content-info">-->
<!--                    <span>{{ i.couponName }}</span>-->
<!--                    <span class="transaction">{{ i.couponUseDesc }}</span>-->
<!--                    <span style="color:#CB4643;">{{ i.endTime }}</span>-->
<!--                  </div>-->
<!--                  <div v-show="i.status == 0" class="qy-button  qy-button-fen" @click="hyActivated(i.userCouponId)">-->
<!--                    <span>激活</span>-->
<!--                  </div>-->
<!--                  <div v-show="i.status != 0" style='position: absolute;right: 0.3rem;top: 0.3rem;'>-->
<!--                    <img v-show="i.status == 0" style="width: 2rem;" src="../../assets/img2/wjh.png">-->
<!--                    <img v-show="i.status == 1" style="width: 2rem;" src="../../assets/img2/yjh.png">-->
<!--                    <img v-show="i.status == 2" style="width: 2rem;" src="../../assets/img2/ysy.png">-->
<!--                  </div>-->
<!--                </div>-->
<!--              </van-list>-->
<!--            </van-tab>-->
<!--          </van-tabs>-->
<!--        </van-tab>-->
      </van-tabs>


      <van-popup
        v-model="showMobileBtn"
        class="mobile-popup"
        :close-on-click-overlay="false"
        round
        position="center"
        :style="{ width: '86%' }"
      >
        <div class="mobile-popup-card">
          <div class="mobile-popup-icon">
            <van-icon name="phone-o" />
          </div>
          <div class="mobile-popup-title">请输入手机号</div>
          <div class="mobile-popup-desc">用于查询并激活您的权益券</div>

          <van-field
            v-model="tel"
            class="mobile-popup-field"
            type="tel"
            maxlength="11"
            clearable
            placeholder="请输入手机号"
            input-align="left"
          />

          <van-button
            block
            class="mobile-popup-submit"
            :loading="telLoading"
            :disabled="telLoading"
            @click="onTelSet"
          >
            确认查询
          </van-button>
        </div>
      </van-popup>

    </van-pull-refresh>
  </div>
</template>

<script>
import {
  getUserCouponList,
  getHyUserCoupons,
  wtdecrypt,
  getToken,
  getuserInfo,
  getOauth2AccessTokenNew,
  getTokenByOpenid,
  activatedCoupon,
  fyActivatedCoupon,
  getNotice,
  getWxConfig,
  getUserArea,
} from "@/api/user";
import { Dialog, Toast } from "vant";
import { mapState } from "vuex";
import { getItem } from "@/utils/storage";
import wxApi from "@/api/wxapi";

import { isWXBrowser, getWechatCode } from "@/api/getcode";
export default {
  name: "home",

  props: {},
  data() {
    return {
      tel:'',
      telLoading: false,
      showMobileBtn:false,
      shows: null, //充值券展示
      notice_text: "",
      openid: "",
      active: 0, //被激活的列表
      actives: 0, //被激活的列表
      activess: 0, //被激活的列表
      channels: [], //频道列表
      isChannelEditShow: false, //频道编辑层
      navlist: [
        {
          name: "未使用",
        },
        {
          name: "已使用",
        },
        {
          name: "已失效",
        },
      ],
      enterpriseType: "0",
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      from: 0,
      status: 0,

      hyLoading: false,
      hyFinished: false,
      fyActives: 0, //被激活的列表
      fyFrom: 0,
      size: 10,
      hyStatus: 0, //状态 0-未使用 2-已使用 3-已失效
      hyList: [],
      couponGroup: 0 // 所属产品模块 0-缴费宝 1-车主
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {},
  async created() {
    if (isWXBrowser) {
      const openid = await this.getWechatOpenid();
      if (!openid) {
        return;
      }
      this.openid = openid;
      let urlinfo = this.geturl();
      let registerUrl = window.location.href;
      let res = await getWxConfig({
        url: registerUrl.split("#")[0],
      });
      wxApi.wxRegister(res.data);

      if (urlinfo != "") {
        this.wtdecryptapi(urlinfo);
        return;
      }

      const hasLogin = await this.loginByOpenid();
      if (hasLogin) {
        return;
      }

      this.showMobileBtn=true;
    } else {
      // this.loadings()

      this.showMobileBtn=true;
    }
    // this.loadings()
    // let registerUrl = window.location.href
    // let res = await getWxConfig({
    //   url: registerUrl.split('#')[0]
    // })
    // wxApi.wxRegister(res.data)
    // this.loadChannels()
  },
  async mounted() {
    // this.onLoad()
    this.record({
      type: 8,
      resourceId: "",
    });
    var datas = await getNotice({ noticeType: "2" });
    if (datas.data.code == "0") {
      this.notice_text = datas.data.data;
    }
  },
  methods: {
    wxRegCallback() {},
    resetCouponState(from = 1) {
      this.list = [];
      this.from = from;
      this.loading = false;
      this.finished = false;
    },
    resetHyState(from = 1) {
      this.hyList = [];
      this.fyFrom = from;
      this.hyLoading = false;
      this.hyFinished = false;
    },
    getEmptyText(type) {
      if (type == 'member') {
        if (this.hyStatus == 2) {
          return '暂无已使用会员权益';
        }
        if (this.hyStatus == 3) {
          return '暂无已失效会员权益';
        }
        return '暂无待激活会员权益';
      }
      if (this.status == 1) {
        return '暂无已使用代金券';
      }
      if (this.status == 2) {
        return '暂无已失效代金券';
      }
      return '暂无待激活代金券';
    },
    getCouponStatusText(status) {
      const value = String(status);
      if (value == '0') {
        return '未激活';
      }
      if (value == '1') {
        return '已激活';
      }
      if (value == '2') {
        return this.status == 2 ? '已失效' : '已使用';
      }
      return '已处理';
    },
    getMemberStatusText(status) {
      const value = String(status);
      if (value == '0') {
        return '未激活';
      }
      if (value == '1') {
        return '已激活';
      }
      if (value == '2') {
        return '已使用';
      }
      if (value == '3') {
        return '已失效';
      }
      return '已处理';
    },
    getCouponStatusClass(status) {
      const value = String(status);
      if (value == '1') {
        return 'coupon-status-active';
      }
      if (value == '2') {
        return this.status == 2 ? 'coupon-status-expired' : 'coupon-status-used';
      }
      return 'coupon-status-default';
    },
    getMemberStatusClass(status) {
      const value = String(status);
      if (value == '1') {
        return 'coupon-status-active';
      }
      if (value == '2') {
        return 'coupon-status-used';
      }
      if (value == '3') {
        return 'coupon-status-expired';
      }
      return 'coupon-status-default';
    },
    selects(val,title) {
      this.active = val;
      this.resetCouponState(1);
      this.resetHyState(1);
      // 之前默认显示了两项
      // if (val == 0) {
      //   this.status = 0;
      //   this.actives = 0;
      //   this.from = 1;
      //   this.enterpriseType = "0";
      //   this.onLoad();
      // } else {
      //   this.enterpriseType = "2";
      //   this.status = 0;
      //   this.activess = 0;
      //   this.from = 1;
      //   this.onLoad();
      // }

      // 切换tab项
      if (title == '商超代金券'){
        this.status = 0;
        this.actives = 0;
        this.enterpriseType = "0";
        this.onLoad();
      } else if (title == '充值券'){
        this.enterpriseType = "2";
        this.status = 0;
        this.activess = 0;
        this.onLoad();
      } else if (title == '出行会员'){
        this.hyStatus = 0;
        this.fyActives = 0;
        this.size = 10;
        this.couponGroup = 1;
        this.onfyLoad();
      } else if (title == '美食商超'){
        this.status = 0;
        this.actives = 0;
        this.enterpriseType = "5";
        this.onLoad();
      } else if (title == '美食会员'){
        this.hyStatus = 0;
        this.fyActives = 0;
        this.size = 10;
        this.couponGroup = 3;
        this.onfyLoad();
      }
    },
    async userinfos() {
      // this.finished=true
    },
    async getWechatOpenid() {
      const storedOpenId = localStorage.getItem('openId');
      if (storedOpenId) {
        return storedOpenId;
      }
      var code = getWechatCode();
      if (!code) {
        return "";
      }
      await this.getopenid(code);
      return this.openid;
    },
    async getopenid(code) {
      const { data } = await getOauth2AccessTokenNew({
        code: code,
      });

      if (data.code == 0 && data.data) {
        this.openid = data.data;
        localStorage.setItem('openId', data.data);
        console.log("123213:" + data.data);
      }
    },
    async loginByOpenid() {
      if (!this.openid) {
        return false;
      }
      const { data } = await getTokenByOpenid({
        openid: this.openid,
      });
      if (data.code == 0 && data.data) {
        await this.loadingByToken(data);
        return true;
      }
      return false;
    },
    async onRefresh() {
      console.log('进入了刷新')
      this.resetCouponState(0);
      this.resetHyState(0);
      try {
        await Promise.all([
          this.loadings(),
          this.hyLoadings()
        ]);
      } finally {
        this.refreshing = false;
      }
    },
    geturl() {
      try {
        var url = window.location.href; //获取当前url
        var dz_url = url.split("#")[1]; //获取#/之后的字符串
        // var dz_url = url.split('#')[0];                //获取#/之前的字符串
        var cs = dz_url.split("?")[1]; //获取?之后的参数字符串
        console.log(cs);
        var cs_arr = cs.split("&"); //参数字符串分割为数组
        var cs = {};
        for (var i = 0; i < cs_arr.length; i++) {
          //遍历数组，拿到json对象
          cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
        }
        return decodeURIComponent(cs.userInfo);
      } catch (e) {
        return "";
        //TODO handle the exception
      }
    },
    async onTelSet(){
      if (this.telLoading) {
        return false;
      }
      const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
      const tel = this.tel ? this.tel.trim() : "";
      this.tel = tel;

      if (tel === '' || tel === undefined || tel === null || !reg.test(tel)) {
        Dialog.alert({
          message: '手机号输入不正确，请检查',
        })
        return false
      }
      this.telLoading = true;
      try {
        let param={
          "mobile": tel,
          openid: this.openid,
        };
        const { data } = await wtdecrypt(param);
        await this.loadingByToken(data);
      } catch (e) {
        Toast.fail('提交失败，请稍后重试');
      } finally {
        this.telLoading = false;
      }
    },
    async wtdecryptapi(userInfo) {
      console.log("sadasd:" + this.openid);
      // userInfo = 'R+JSr79J/UPcCR18iYSidU9qOLMJZG7F19erYXyOWEUYuqsDdtXuZKGBPnZ0sQeakGakH7u5y8Go7V+pOx2J3g=='
      let parma = {
        userInfo: userInfo,
        openid: this.openid,
        // "openid": 'oGWjZs8LKqM7MJHpS-aZLryaTwMI',
      };
      const { data } = await wtdecrypt(parma);

      if (data.code == "500100") {
        Dialog.alert({
          message: "当前页面已失效，请重新进入当前页面",
        }).then(() => {
          // on close
        });

        return;
      }

      this.loadingByToken(data);


      //this.get_token(data.data);
    },

    async loadingByToken(data){
      if (data.code != 0 || !data.data) {
        Dialog.alert({
          message: data.msg || "登录失败，请检查手机号",
        });
        return;
      }
      var dats = {
        token: data.data,
      };
      this.$store.dispatch("AddUser", dats).then(() => {
        if (localStorage.getItem("userArea") != null) {
          let res = JSON.parse(localStorage.getItem("userArea"));
          this.shows = res.id;
        }
      });
      // this.$store.commit('setUser', dats)

      var datas = await getuserInfo();

      console.log(datas.data.data.userType);
      this.userType = datas.data.data.userType;

      if (this.userType != "1") {
        Dialog.alert({
          title: "",
          message: "请到中国联通APP开通生活权益会员！",
        });
        return;
      }
      this.showMobileBtn=false;
      this.loadings();
    },

    async get_token(mobile) {
      let param = {
        mobile: mobile,
      };

      const { data } = await getToken(param);

      if (data.code == 0) {
        var dats = {
          token: data.data,
        };
        this.$store.dispatch("AddUser", dats).then(() => {
          if (localStorage.getItem("userArea") != null) {
            let res = JSON.parse(localStorage.getItem("userArea"));
            this.shows = res.id;
          }
        });
        // this.$store.commit('setUser', dats)
      }

      var datas = await getuserInfo();

      console.log(datas.data.data.userType);
      this.userType = datas.data.data.userType;

      if (this.userType != "1") {
        Dialog.alert({
          title: "",
          message: "请到中国联通APP开通生活权益会员！",
        });
        return;
      }
      this.loadings();
    },
    async activated(id) {
      Toast.loading({
        message: "激活中请稍等...",
        forbidClick: true,
      });

      let parma = {
        // userId:12,
        //   "userMobile":"15028155600",
        busiUserCouponId: id,
      };
      const { data } = await activatedCoupon(parma);

      Toast.clear();

      Dialog.alert({
        title: "",
        message: data.msg,
      }).then(() => {
        this.resetCouponState(0);
        this.loadings();
        // location.reload()
        // this.$router.go(0)
      });
    },
    // 出行会员 激活
    async hyActivated(id) {
      Toast.loading({
        message: "激活中请稍等...",
        forbidClick: true,
      });

      let parma = {
        userCouponId: id,
      };
      const { data } = await fyActivatedCoupon(parma);

      Toast.clear();

      Dialog.alert({
        title: "",
        message: data.msg,
      }).then(() => {
        this.resetHyState(0);
        this.hyLoadings();
      });
    },
    selectstatus(name, title) {
      this.status = name;
      this.resetCouponState(1);
      this.onLoad();
    },
    // 出行会员
    selectfyStatus(name, title) {
      if (title == '未使用'){
        this.hyStatus = 0;
      } else if (title == '已使用'){
        this.hyStatus = 2;
      } else if (title == '已失效'){
        this.hyStatus = 3;
      }
      this.resetHyState(1);
      this.size = 10;
      this.couponGroup = 1;
      this.onfyLoad();
    },
    async loadings() {
      if (this.finished) {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.from = this.from + 1;
      try {
        await this.onLoad();
      } finally {
        this.loading = false;
      }
    },
    async hyLoadings() {
      if (this.hyFinished) {
        this.hyLoading = false;
        return;
      }
      this.hyLoading = true;
      this.fyFrom = this.fyFrom + 1;
      try {
        await this.onfyLoad();
      } finally {
        this.hyLoading = false;
      }
    },
    // 商超代金券,充值券
    async onLoad() {
      console.log(this.from);
      let parma = {
        // userId:12,
        //   "userMobile":"15028155600",
        from: this.from,
        enterpriseType: this.enterpriseType,
        size: 10,
        status: this.status,
      };
      const { data } = await getUserCouponList(parma);
      const rows = Array.isArray(data.data) ? data.data : [];
      if (rows.length < parma.size) {
        this.finished = true;
      }

      if (this.from <= 1) {
        this.list = rows;
      } else {
        rows.forEach((i, k) => {
          this.list.push(i);
        });
      }
    },
    // 缴费宝，出行会员领裙记录
    async onfyLoad() {
      console.log('出行会员页码',this.fyFrom);
      let parma = {
        from: this.fyFrom,
        size: this.size,
        status: this.hyStatus,
        couponGroup: this.couponGroup
      };
      const { data } = await getHyUserCoupons(parma);
      const sourceRows = Array.isArray(data.data) ? data.data : [];
      const rows = sourceRows.filter(i => !i.couponUseDesc || !i.couponUseDesc.includes('支付宝'));
      if (sourceRows.length < parma.size) {
        this.hyFinished = true;
      }
      if (this.fyFrom <= 1) {
        this.hyList = rows;
      } else {
        rows.forEach((i, k) => {
          this.hyList.push(i);
        });
      }
    }
  },
};
</script>

<style lang="less">
.home-container {
  min-height: 100vh;
  background: #f6f7f9;
  padding-bottom: 0.4rem;
  box-sizing: border-box;

  .van-list {
    // height: calc(100vh - 4.2rem);
    // overflow: auto;
  }

  .page-hero {
    margin: 0.24rem 0.28rem 0.18rem;
    padding: 0.36rem 0.34rem;
    border-radius: 0.18rem;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 0.08rem 0.24rem rgba(31, 35, 41, 0.06);
  }

  .page-hero-title {
    color: #222222;
    font-size: 0.46rem;
    line-height: 0.6rem;
    font-weight: 700;
  }

  .page-hero-desc {
    margin-top: 0.08rem;
    color: #777777;
    font-size: 0.28rem;
    line-height: 0.42rem;
  }

  .page-hero-badge {
    flex: 0 0 auto;
    height: 0.56rem;
    padding: 0 0.22rem;
    border-radius: 0.28rem;
    background: #fff2f1;
    color: #cb4643;
    font-size: 0.26rem;
    line-height: 0.56rem;
    font-weight: 700;
  }

  .main-tabs {
    > .van-tabs__wrap {
      height: 0.92rem;
      margin: 0 0.28rem;
      border-radius: 0.18rem;
      overflow: hidden;
      box-shadow: 0 0.06rem 0.18rem rgba(31, 35, 41, 0.05);
    }

    > .van-tabs__wrap .van-tabs__nav {
      background: #ffffff;
    }

    > .van-tabs__wrap .van-tab {
      color: #666666;
      font-size: 0.32rem;
    }

    > .van-tabs__wrap .van-tab--active {
      color: #cb4643;
      font-weight: 700;
    }

    > .van-tabs__wrap .van-tabs__line {
      width: 0.56rem;
      height: 0.06rem;
      border-radius: 0.04rem;
      background: #cb4643;
    }
  }

  .navtab {
    margin-top: 0.16rem;

    .van-tabs__wrap {
      height: 0.78rem;
      padding: 0 0.28rem;
      background: transparent;
    }

    .van-tabs__nav {
      background: transparent;
    }

    .van-tab {
      color: #777777;
      font-size: 0.3rem;
    }

    .van-tab--active {
      color: #222222;
      font-weight: 700;
    }

    .van-tabs__line {
      width: 0.44rem;
      height: 0.05rem;
      background: #222222;
      border-radius: 0.04rem;
    }
  }

  .coupon-card {
    min-height: 2.3rem;
    margin: 0.2rem 0.28rem;
    padding: 0.28rem;
    border-radius: 0.18rem;
    background: #ffffff;
    box-shadow: 0 0.08rem 0.22rem rgba(31, 35, 41, 0.06);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 0.22rem;
  }

  .coupon-logo {
    width: 1.34rem;
    height: 1.34rem;
    flex: 0 0 1.34rem;
    border-radius: 0.16rem;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .coupon-main {
    min-width: 0;
    flex: 1;
  }

  .coupon-title {
    color: #222222;
    font-size: 0.34rem;
    line-height: 0.46rem;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .coupon-desc {
    max-width: 3.5rem;
    margin-top: 0.14rem;
    padding: 0.06rem 0.18rem;
    border-radius: 0.28rem;
    background: #fff2f1;
    color: #cb4643;
    font-size: 0.26rem;
    line-height: 0.36rem;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .coupon-time {
    margin-top: 0.14rem;
    color: #888888;
    font-size: 0.26rem;
    line-height: 0.36rem;
  }

  .coupon-side {
    width: 1.36rem;
    flex: 0 0 1.36rem;
    display: flex;
    justify-content: flex-end;
  }

  .coupon-action.van-button {
    min-width: 1.24rem;
    height: 0.62rem;
    padding: 0 0.18rem;
    border: none;
    border-radius: 0.31rem;
    background: #cb4643;
    color: #ffffff;
    font-size: 0.26rem;
    font-weight: 700;
    white-space: nowrap;
  }

  .coupon-status {
    min-width: 1.08rem;
    height: 0.52rem;
    padding: 0 0.16rem;
    border-radius: 0.26rem;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.24rem;
    font-weight: 700;
    white-space: nowrap;
  }

  .coupon-status-active {
    background: #eef7f1;
    color: #21864b;
  }

  .coupon-status-used {
    background: #eef1f5;
    color: #6b7280;
  }

  .coupon-status-expired,
  .coupon-status-default {
    background: #f4f4f5;
    color: #999999;
  }

  .coupon-empty {
    padding: 0.8rem 0 1rem;
  }

  .mobile-popup {
    overflow: hidden;
    background: #ffffff;
    border-radius: 0.28rem;
  }

  .mobile-popup-card {
    padding: 0.58rem 0.5rem 0.52rem;
    text-align: center;
    box-sizing: border-box;
  }

  .mobile-popup-icon {
    width: 1.08rem;
    height: 1.08rem;
    margin: 0 auto 0.28rem;
    border-radius: 50%;
    background: #f7eeee;
    color: #cb4643;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.52rem;
  }

  .mobile-popup-title {
    font-size: 0.44rem;
    line-height: 0.62rem;
    font-weight: 700;
    color: #222222;
  }

  .mobile-popup-desc {
    margin-top: 0.12rem;
    font-size: 0.28rem;
    line-height: 0.42rem;
    color: #888888;
  }

  .mobile-popup-field {
    margin-top: 0.42rem;
    border-radius: 0.16rem;
    background: #f7f7f8;
    overflow: hidden;
  }

  .mobile-popup-field.van-cell {
    padding: 0.3rem 0.32rem;
    background: #f7f7f8;
  }

  .mobile-popup-submit {
    height: 0.92rem;
    margin-top: 0.36rem;
    border: none;
    border-radius: 0.16rem;
    background: #cb4643;
    color: #ffffff;
    font-size: 0.34rem;
    font-weight: 700;
  }

  .mobile-popup-submit.van-button--disabled {
    opacity: 0.72;
  }

  .qy-content {
    position: relative;
    width: 100%;
    height: 2.8rem;

    background-size: 100% 100%;
    margin: 0.2rem 0;
    display: flex;
  }

  .qy-fen {
    background-image: url(../../assets/img/quanyifen.png);
  }

  .qy-hui {
    background-image: url(../../assets/img/qianyihui.png);
  }

  .qy-content-img {
    img {
      width: 1.8rem;
      height: 2.2rem;
      display: block;
      padding: 0.3rem 0.35rem;
    }
  }

  .qy-content-info {
    padding-top: 0.2rem;

    span {
      display: block;

      line-height: 0.8rem;
      margin-left: 0.5rem;

      &:nth-child(1) {
        font-size: 0.34rem;
        font-weight: 700;
      }

      &:nth-child(3) {
        font-size: 0.32rem;
        color: #cb4643;
      }
    }
    .transaction {
      font-size: .3rem;
      background: #ffe9e9;
      border-radius: 0.48rem;
      text-align: center;
      width: 2.5rem;
      color: #e60027;
    }
    .endTime {
      font-size: 0.32rem;
      color: #CB4643;
    }
  }

  .qy-button {
    width: 1rem;
    height: 100%;
    background-size: 100% 100%;
    position: absolute;
    right: 0.05rem;

    span {
      font-size: 0.38rem;
      display: block;
      width: 25%;
      color: #ffffff;
      text-align: center;
      margin: 0.8rem auto;
    }
  }

  .qy-button-fen {
    background-image: url(../../assets/img/quanyijihuo.png);
  }

  .qy-button-hui {
    background-image: url(../../assets/img/quanyiweijihuo.png);

    span {
      color: #999999 !important;
    }
  }
}
</style>
